import { render, staticRenderFns } from "./GroupTypes.vue?vue&type=template&id=08d1ac28"
import script from "./GroupTypes.vue?vue&type=script&lang=js"
export * from "./GroupTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports